/**
 * Popup "hide after button click".
 *
 * When the editor enables the toggle, the button wrapper carries
 * `data-pum-hide-after-click="{popupId}"` (see frontend-hooks.php). On click we
 * write PUM's dismissal cookie synchronously — before navigation — so the popup
 * stays closed on the destination page. Generalises the old per-popup snippet.
 *
 * @returns {void}
 */
function popupHideAfterClick() {
    const COOKIE_DAYS = 30; // 30-day suppression; matches PUM's default cookie duration.

    // Resolve the cookie name(s) PUM actually uses for this popup from its
    // `data-popmake` config, so we match even if the editor renamed it.
    // Falls back to PUM's default `pum-{id}`.
    function getCookieNames(popupId) {
        const fallback = [`pum-${popupId}`];
        const container = document.getElementById(`pum-${popupId}`);
        const raw = container && container.getAttribute('data-popmake');

        if (!raw) {
            return fallback;
        }

        try {
            const config = JSON.parse(raw);
            const cookies = Array.isArray(config.cookies) ? config.cookies : [];
            // PUM stores cookies as {name} or {settings.name}; check both, dedupe.
            const names = [
                ...new Set(
                    cookies
                        .flatMap((c) => [
                            c && c.name,
                            c && c.settings && c.settings.name,
                        ])
                        .filter(Boolean),
                ),
            ];

            return names.length ? names : fallback;
        } catch (error) {
            return fallback;
        }
    }

    // Delegated so it covers all popups and survives AJAX DOM changes.
    document.addEventListener('click', function (e) {
        const wrapper = e.target.closest(
            '.pum-popup-button[data-pum-hide-after-click]',
        );

        if (!wrapper || !e.target.closest('a')) {
            return;
        }

        const popupId = wrapper.getAttribute('data-pum-hide-after-click');

        if (!popupId) {
            return;
        }

        const expires = new Date();
        expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
        const expiresUtc = expires.toUTCString();

        getCookieNames(popupId).forEach((name) => {
            document.cookie = `${name}=true; expires=${expiresUtc}; path=/; SameSite=Lax`;
        });
    });
}

export default popupHideAfterClick;
